import * as actionTypes from "./actionTypes";
import ContrattoDigitaleService from "../../api/contrattoDigitaleService";
import {store} from "../store";

export const getContractCardData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.GET_CONTRACT_CARD_DATA_OR_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.getDigitalContracts(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_CONTRACT_CARD_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_CONTRACT_CARD_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getContractDetailsData = (digitalContractId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.GET_CONTRACT_DETAILS_DATA_OR_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.getContractDetails(integrationId, digitalContractId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_CONTRACT_DETAILS_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_CONTRACT_DETAILS_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getContractTablesData = (digitalContractId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_CONTRACT_TABLES_DATA_OR_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.getContractTables(integrationId, digitalContractId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_CONTRACT_TABLES_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_CONTRACT_TABLES_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const fetchSimsAssociatedToPlan = (serviceType, commercialLabel, profilo, page, rowsPerPage, sort, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const msisdn = filter.numeroDiTelefono.value === "" ? null : filter.numeroDiTelefono.value
    const iccId = filter.seriale.value === "" ? null : filter.seriale.value
    const tags = filter.tags.value.map(f => f.label).join(",");
    const piano = filter.piano.value === "" ? null : filter.piano.value

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: true, key: 'loading'})
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: false, key: 'error'})
        ContrattoDigitaleService.getSimsAssociatedToPlan(integrationId, serviceType, commercialLabel, profilo, page, rowsPerPage, sort, msisdn, iccId, tags, piano)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                if(e.response.data.status.includes("400")){
                    dispatch({
                        type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING,
                        value: {data: [], totalItems: 0},
                        key: 'data'
                    })
                } else{
                    dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: true, key: 'error'})
                }
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const fetchSimsAssociatedToPlafondShare = (serviceType, commercialLabel, profilo, page, rowsPerPage, sort, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const msisdn = filter.numeroDiTelefono.value === "" ? null : filter.numeroDiTelefono.value
    const iccId = filter.seriale.value === "" ? null : filter.seriale.value
    const piano = filter.piano.value === "" ? null : filter.piano.value
    const tags = filter.tags.value.map(f => f.label).join(",");

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: true, key: 'loading'})
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: false, key: 'error'})
        ContrattoDigitaleService.fetchPlafondShareAssociatedSims(integrationId, serviceType, commercialLabel, profilo, page, rowsPerPage, sort, msisdn, iccId, tags, piano)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                if(e.response.data.status.includes("400")){
                    dispatch({
                        type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING,
                        value: {data: [], totalItems: 0},
                        key: 'data'
                    })
                } else{
                    dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: true, key: 'error'})
                }
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getSimsAssociatedToPlanFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA, value: true, key: 'loading'})
        ContrattoDigitaleService.getSimsAssociatedToPlanFilterData(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA, value: false, key: 'loading'})
            })
    }
}

export const fetchSimsAssociatedToOption = (commercialLabel, page, rowsPerPage, sort, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const msisdn = filter.numeroDiTelefono.value === "" ? null : filter.numeroDiTelefono.value
    const iccId = filter.seriale.value === "" ? null : filter.seriale.value
    const piano = filter.piano.value === "" ? null : filter.piano.value
    const tags = filter.tags.value.map(f => f.label).join(",");

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING, value: true, key: 'loading'})
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING, value: false, key: 'error'})
        ContrattoDigitaleService.getSimsAssociatedToOption(integrationId, commercialLabel, page, rowsPerPage, sort, msisdn, iccId, tags, piano)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING, value: true, key: 'error'})
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getSimsAssociatedToOptionFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA, value: true, key: 'loading'})
        ContrattoDigitaleService.getSimsAssociatedToOptionFilterData(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA, value: false, key: 'loading'})
            })
    }
}

export const fetchSimsNotAssociatedToOption = (commercialLabel, page, rowsPerPage, sort, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const msisdn = filter.numeroDiTelefono.value === "" ? null : filter.numeroDiTelefono.value
    const iccId = filter.seriale.value === "" ? null : filter.seriale.value
    const piano = filter.piano.value === "" ? null : filter.piano.value

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING, value: true, key: 'loading'})
        dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING, value: false, key: 'error'})
        ContrattoDigitaleService.getSimsNotAssociatedToOption(integrationId, commercialLabel, page, rowsPerPage, sort, msisdn, iccId, filter.tags.value.join(','), piano)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING, value: true, key: 'error'})
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getSimsNotAssociatedToOptionFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_FILTER_DATA, value: true, key: 'loading'})
        ContrattoDigitaleService.getSimsNotAssociatedToOptionFilterData(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_FILTER_DATA,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_FILTER_DATA, value: false, key: 'loading'})
            })
    }
}

export const getDeviceTableData = (digitalContractId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.GET_DEVICE_TABLES_DATA_OR_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.getDeviceTable(integrationId, digitalContractId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DEVICE_TABLES_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
                dispatch({
                    type: actionTypes.GET_DEVICE_TABLES_DATA_OR_LOADING,
                    value: [],
                    key: 'data'
                })
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DEVICE_TABLES_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getDeviceDetailsDataConsgne = (digitalContractId, deviceCommercialLabel) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        dispatch({type: actionTypes.GET_DEVICE_DETAILS_CONSEGNE_DATA_OR_LOADING, value: true, key: 'loading'})
        dispatch({
            type: actionTypes.GET_DEVICE_DETAILS_CONSEGNE_DATA_OR_LOADING,
            value: {deviceConsegneList: []},
            key: 'data'
        })
        ContrattoDigitaleService.getDeviceDetailsConsegne(integrationId, digitalContractId, deviceCommercialLabel)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DEVICE_DETAILS_CONSEGNE_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DEVICE_DETAILS_CONSEGNE_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getDeviceDetailsDataConsgnati = (deviceCommercialLabel, orderId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        dispatch({type: actionTypes.GET_DEVICE_DETAILS_CONSEGNATI_DATA_OR_LOADING, value: true, key: 'loading'})
        dispatch({
            type: actionTypes.GET_DEVICE_DETAILS_CONSEGNATI_DATA_OR_LOADING,
            value: {deviceConsegnatiList: []},
            key: 'data'
        })
        ContrattoDigitaleService.getDeviceDetailsConsegnati(integrationId, deviceCommercialLabel, orderId)
            .then((res) => {
                console.log(res.data, 919191)
                dispatch({
                    type: actionTypes.GET_DEVICE_DETAILS_CONSEGNATI_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DEVICE_DETAILS_CONSEGNATI_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getSuitableSimList = (commercialLabel) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.GET_SUITABLE_SIM_LIST, value: true, key: 'loading'})
        ContrattoDigitaleService.getSuitableSimList(integrationId, commercialLabel)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SUITABLE_SIM_LIST,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.data);
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SUITABLE_SIM_LIST, value: false, key: 'loading'})
            })
    }
}

export const fetchCurrentPlan = (commercialLabel, idTrattativa) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: true})

        ContrattoDigitaleService.fetchCurrentPlan(commercialLabel, idTrattativa, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DC_FETCH_CURRENT_OFFER,
                    key: "data",
                    payload: res.data
                })
            })
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: false})
            })
    }
}

export const getCurrentPlafondShare = (commercialLabel, idTrattativa) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: true})

        ContrattoDigitaleService.fetchCurrenPlafondShare(commercialLabel, idTrattativa, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DC_FETCH_CURRENT_OFFER,
                    key: "data",
                    payload: res.data
                })
            })
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: false})
            })
    }
}

export const getOpzioniPlanDetails = (commercialLabel, idTrattativa, slug) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: true})

        ContrattoDigitaleService.fetchCurrentOpzioniPlan(integrationId, idTrattativa, commercialLabel, slug)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DC_FETCH_CURRENT_OFFER,
                    key: "data",
                    payload: res.data
                })
            })
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DC_FETCH_CURRENT_OFFER, key: "loading", payload: false})
            })
    }
}

export const getServiceTablesData = (digitalContractId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SERVICE_DATA_OR_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.fetchServiceLists(integrationId, digitalContractId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SERVICE_DATA_OR_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SERVICE_DATA_OR_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getApnLists = (digitalContractId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_APN_TABLES_DATA_AND_LOADING, value: true, key: 'loading'})
        ContrattoDigitaleService.fetchApnLists(integrationId, digitalContractId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_APN_TABLES_DATA_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_APN_TABLES_DATA_AND_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getServiceDetailsData = (apnName, apnType) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SERVICE_DETAILS_OR_LOADING, key: 'loading', value: true})
        ContrattoDigitaleService.fetchServiceDetails(integrationId, apnName, apnType)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SERVICE_DETAILS_OR_LOADING,
                    key: 'data',
                    value: res.data.simItems
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SERVICE_DETAILS_OR_LOADING, key: 'loading', value: false})
            })
    }
}

export const getCollaboratorsForSimFilter = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_SIM_FILTER_COLLABORATORS, key: 'loading', value: true})
        dispatch({type: actionTypes.GET_SIM_FILTER_COLLABORATORS, key: 'data', value: []})
        ContrattoDigitaleService.fetchCollaboratorsForSimFilter(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIM_FILTER_COLLABORATORS,
                    key: 'data',
                    value: res.data
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_SIM_FILTER_COLLABORATORS, key: 'loading', value: false})
            })
    }
}

export const getApnSims = (page, rowsPerPage, sortBy, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const sortParts = sortBy.split(',')
    const msisdn = filter.msisdn.value === "" ? null : filter.msisdn.value
    const iccid = filter.iccid.value === "" ? null : filter.iccid.value
    const tipoApn = filter.tipoApn.value === "" ? null : filter.tipoApn.value
    const nomeApn = filter.nomeApn.value === "" ? null : filter.nomeApn.value
    const tags = filter.tags.value.map(f => f.label).join(",");
    return (dispatch) => {
        dispatch({type: actionTypes.GET_APN_SIMS_TABLE_AND_LOADING, key: 'loading', value: true})
        ContrattoDigitaleService.fetchApnSims(integrationId, page, rowsPerPage, sortParts[0],
            sortParts[1].toUpperCase(), iccid, msisdn, tipoApn, nomeApn, tags)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_APN_SIMS_TABLE_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_APN_SIMS_TABLE_AND_LOADING, key: 'loading', value: false})
            })
    }
}

export const getApnSimsFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_APN_SIMS_FILTER_DATA_AND_LOADING, key: 'loading', value: true})
        ContrattoDigitaleService.fetchApnSimsFilterData(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_APN_SIMS_FILTER_DATA_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_APN_SIMS_FILTER_DATA_AND_LOADING, key: 'loading', value: false})
            })
    }
}
